export default __webpack_public_path__ + "static/media/welcome.57c91688.png";